import React from 'react'

const GoogleIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                fill="#4285F4"
                d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"
            />
            <path
                fill="#34A853"
                d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.59-3.87-12.32-9.07H4.32v5.7C7.94 41.07 15.38 46 24 46z"
            />
            <path
                fill="#FBBC05"
                d="M11.68 28.18A13.21 13.21 0 0 1 11 24c0-1.45.25-2.86.68-4.18v-5.7H4.32A21.96 21.96 0 0 0 2 24c0 3.55.85 6.91 2.32 9.88l7.36-5.7z"
            />
            <path
                fill="#EA4335"
                d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.38 2 7.94 6.93 4.32 14.12l7.36 5.7c1.73-5.2 6.59-9.07 12.32-9.07z"
            />
        </svg>
    )
}

export default GoogleIcon